import type { CurrencyCode } from 'pi-kiosk-shared';
import { isCurrencyCode } from 'pi-kiosk-shared';
import i18n from '../../i18n.js';
import { resolveCustomerLocaleTag } from '../hooks/useCustomerLocaleTag.js';

/** Fallback when session/payment currency is unavailable (W17). */
export const CUSTOMER_CURRENCY_FALLBACK = 'CZK' as const satisfies CurrencyCode;

/**
 * @deprecated Prefer {@link resolveCustomerCurrency} once session currency is wired.
 */
export const CUSTOMER_CURRENCY = CUSTOMER_CURRENCY_FALLBACK;
export type CustomerCurrency = CurrencyCode | string;

export function resolveCustomerCurrency(
  sessionCurrency: string | null | undefined,
): CurrencyCode {
  return isCurrencyCode(sessionCurrency) ? sessionCurrency : CUSTOMER_CURRENCY_FALLBACK;
}

export function formatPriceAmount(
  amountMajor: number,
  currency: CustomerCurrency = CUSTOMER_CURRENCY_FALLBACK,
  localeTag?: string
): string {
  const safe = Number.isFinite(amountMajor) ? amountMajor : 0;
  const resolvedLocale =
    localeTag ?? resolveCustomerLocaleTag(i18n.resolvedLanguage ?? i18n.language);
  const code =
    typeof currency === 'string' && currency.trim().length > 0
      ? currency.trim()
      : CUSTOMER_CURRENCY_FALLBACK;

  return new Intl.NumberFormat(resolvedLocale, {
    style: 'currency',
    currency: code,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(safe);
}
